import React from "react";

const AnimatedBackground = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: -1,
      overflow: "hidden"
    }}
  >
    <svg width="100vw" height="100vh" viewBox="0 0 1920 1080" preserveAspectRatio="none"
         style={{width: "100vw", height: "100vh", position: "absolute", top: 0, left: 0}}>
      <g>
        <AnimatedLine
          d="M 0 200 Q 480 250 960 200 Q 1440 150 1920 200"
          color="#e8521d"
          duration="10s"
          delay="0s"
        />
        <AnimatedLine
          d="M 0 400 Q 480 450 960 400 Q 1440 350 1920 400"
          color="#7f9733"
          duration="12s"
          delay="2s"
        />
        <AnimatedLine
          d="M 0 600 Q 480 650 960 600 Q 1440 550 1920 600"
          color="#000000"
          duration="14s"
          delay="4s"
        />
      </g>
    </svg>
    <style>
      {`
        .animated-path {
          stroke-width: 100;
          fill: none;
          opacity: 0.25;
        }
        .animated-path-1 {
          animation: movePath1 10s linear infinite alternate;
        }
        .animated-path-2 {
          animation: movePath2 12s linear infinite alternate;
        }
        .animated-path-3 {
          animation: movePath3 14s linear infinite alternate;
        }
        @keyframes movePath1 {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 1200; }
        }
        @keyframes movePath2 {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 800; }
        }
        @keyframes movePath3 {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 1000; }
        }
      `}
    </style>
  </div>
);

const AnimatedLine = ({ d, color, duration, delay }) => (
  <path
    d={d}
    stroke={color}
    className={`animated-path animated-path-${color === "#e8521d" ? "1" : color === "#7f9733" ? "2" : "3"}`}
    style={{
      strokeDasharray: 2000,
      strokeDashoffset: 0,
      animationDuration: duration,
      animationDelay: delay
    }}
  />
);

export default AnimatedBackground;
